/** @jsxImportSource @emotion/react */
import { Box, Button } from '@mui/material'
import { useAtom, useAtomValue } from 'jotai'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { selectedStoryAtom, selectedStoryIdAtom } from '@app/services/storiesService'
import {
  backButton,
  buttons,
  nextButton,
  summaryPageContainer,
  summaryPageContent,
  summaryPageCopy,
  theLogos,
} from './RiskStorySummaryPage.style'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { ErrorPage } from '@app/routes/ErrorPage'
import { PUBLIC_ASSETS_BASE_URL } from '@app/app-constants'
import { lazy } from 'react'

const UiMarkdown = lazy(() => import('@app/components/Atoms/UiMarkdown/UiMarkdown'))

const RiskStorySummaryPage = () => {
  const navigate = useNavigate()

  const { storyId, slug } = useParams<{ storyId?: string; slug?: string }>()

  const [selectedStoryId, setSelectedStoryId] = useAtom(selectedStoryIdAtom)
  if (storyId && selectedStoryId !== Number(storyId)) {
    setSelectedStoryId(Number(storyId))
  }

  const story = useAtomValue(selectedStoryAtom)

  const previousClick = () => {
    navigate(`/risk/stories/${storyId}/${slug}/view`)
  }

  const nextClick = () => {
    navigate(`/risk/stories/${storyId}/${slug}/view/chapters`)
  }

  if (story instanceof Error) {
    if (story.message != 'Not found') return <ErrorPage />
    // Navigate to /view to show not found message
    let path = location.pathname
    if (path.endsWith('/')) path = path.substring(0, path.length - 1)
    const pathBits = path.split('/')
    pathBits.pop()
    return <Navigate to={pathBits.join('/')} />
  }

  return (
    <Box css={summaryPageContainer(story?.branding)}>
      <Box css={theLogos}>
        <img
          className="theClientLogo"
          src={`${PUBLIC_ASSETS_BASE_URL}/images/shared/new_RexLogoFull.svg`}
          alt="Logo"
        />
        <span style={{ width: '100%' }}></span>
      </Box>
      <Box css={summaryPageContent(story?.branding)}>
        PROJECT SUMMARY
        <h1>{story?.title}</h1>
        <UiMarkdown css={summaryPageCopy}>{story?.summary ?? ''}</UiMarkdown>
      </Box>
      <Box css={buttons}>
        <Button variant="outlined" css={backButton(story?.branding)} onClick={previousClick}>
          <ChevronLeft /> Back
        </Button>
        <Button css={nextButton(story?.branding)} onClick={nextClick}>
          Next <ChevronRight />
        </Button>
      </Box>
    </Box>
  )
}
export default RiskStorySummaryPage
